import { Modal, Typography } from 'antd';
import { useCallback } from 'react';

import type { PortfolioDeleteModalProps } from '@pages/Portfolio/types';

import type { FC } from 'react';

const { Paragraph } = Typography;

export const PortfolioDeleteModal: FC<PortfolioDeleteModalProps> = ({
  open,
  confirmLoading,
  portfolio,
  onCancel,
  onConfirm,
  disabled,
}) => {
  const handleOk = useCallback(() => {
    void onConfirm();
  }, [onConfirm]);

  return (
    <Modal
      open={open}
      title="Удалить изображение"
      okText="Удалить"
      cancelText="Отмена"
      confirmLoading={confirmLoading}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnHidden
      okButtonProps={{ disabled, danger: true }}
      cancelButtonProps={{ disabled }}
    >
      <Paragraph>
        Вы действительно хотите удалить элемент портфолио
        {portfolio?.Description ? ` «${portfolio.Description}»` : ''}?
      </Paragraph>
    </Modal>
  );
};
